import { render, staticRenderFns } from "./FormModalAssociate.vue?vue&type=template&id=0de8b09e&"
import script from "./FormModalAssociate.vue?vue&type=script&lang=js&"
export * from "./FormModalAssociate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports